<template>
  <div ref="captcha" />
</template>

<script>
import has from 'lodash/has';

export default {
  props: {
    siteKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      ready: false
    }
  },

  mounted() {
    this.loadCaptchaScript();
  },

  methods: {
    renderCaptcha() {
      window.hcaptcha.render(this.$refs.captcha, {
        sitekey: this.siteKey,
        callback: this.callback,
        hl: this.$i18n.locale,
      });
    },

    callback(token) {
      this.$emit('result', token);
    },

    initialize() {
      if (! has(window, 'hcaptcha.render')) {
        this.loadCaptchaScript();
      } else {
        this.renderCaptcha();
      }
    },

    loadCaptchaScript() {
      const script = document.createElement('script');
      window.onloadCallback = this.renderCaptcha;
      script.src = 'https://js.hcaptcha.com/1/api.js?onload=onloadCallback&render=explicit';
      document.head.appendChild(script);
    }
  }
}
</script>